export default __webpack_public_path__ + "menu-arrow-icon.a913a98d66feee5a02b53fd3b1fbe95b.svg";